import { PatientDtoResidencyPermit } from '../api/generated/model';

export function getResidencyPermitName(permit: PatientDtoResidencyPermit) {
  switch (permit) {
    case PatientDtoResidencyPermit.NONE:
      return 'Illegaler Aufenthalt';
    case PatientDtoResidencyPermit.L_SHORT_RESIDENCE:
      return 'L - Kurzaufenthaltsbewilligung';
    case PatientDtoResidencyPermit.F_TEMPORARY:
      return 'F - Vorläufig aufgenommener Ausländer';
    case PatientDtoResidencyPermit.N_ASYLUM:
      return 'N - Asylsuchend';
    case PatientDtoResidencyPermit.S_PROTECTED:
      return 'S - Schutzbedürftige';
    case PatientDtoResidencyPermit.B_RESIDENCE:
      return 'B - Aufenthaltsbewilligung';
    case PatientDtoResidencyPermit.C_SETTLEMENT:
      return 'C - Niederlassungsbewilligung';
    case PatientDtoResidencyPermit.CI_RESIDENCE_WORKING:
      return 'Ci - Aufenthaltsbewilligung mit Erwerbstätigkeit';
    case PatientDtoResidencyPermit.G_BORDER:
      return 'G - Grenzgänger';
    case PatientDtoResidencyPermit.NATURALIZED_CITIZEN:
      return 'Ausländer und in der Schweiz eingebürgert';
    case PatientDtoResidencyPermit.SWISS_BORN:
      return 'Schweizer und in der Schweiz geboren';
    case PatientDtoResidencyPermit.TOURIST:
      return 'Tourist';
    case PatientDtoResidencyPermit.UNKNOWN:
      return 'Unbekannt';
  }
}
